window.onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
  var player;
  if (document.getElementsByClassName('MediaItem__Image')) {
    var videoElements = document.getElementsByClassName('MediaItem__Image');

    for (let index = 0; index < videoElements.length; index++) {
      const videoContainer = videoElements[index];

      for (var i = 0; i < videoContainer.childNodes.length; i++) {
        var videoPlayerElement = videoContainer.childNodes[i].firstChild;
        if (videoPlayerElement.tagName.toLowerCase() == 'iframe') {
          player = new YT.Player(videoPlayerElement, {
            events: {
              onReady: onPlayerReady,
              onStateChange: onPlayerStateChange,
            },
          });
        }
      }
    }
  }
};

// Hide the info bar if the player is already running.
// This could happen if the video was clicked before the api has fully loaded
function onPlayerReady(event) {
  const infobar = event.target.g
    .closest('.MediaItem')
    .querySelector('.MediaItem__InfoBar');
  if (
    event.target.getPlayerState() === YT.PlayerState.PLAYING &&
    infobar.style.display !== 'none'
  ) {
    infobar.style.display = 'none';
    console.info('Infobar hidden after video playing');
  }
}

function onPlayerStateChange(event) {
  var parentNode = event.target.g.parentNode.parentNode.parentNode;
  var videoInfoBar;

  for (var i = 0; i < parentNode.childNodes.length; i++) {
    if (parentNode.childNodes[i].className == 'MediaItem__InfoBar') {
      videoInfoBar = parentNode.childNodes[i];
    }
  }

  if (event.data == YT.PlayerState.PLAYING) {
    videoInfoBar.style.display = 'none';
  } else {
    videoInfoBar.style.display = 'block';
  }
}

if (document.getElementsByTagName('video')) {
  var videoElements = document.getElementsByTagName('video');
  var videoInfoBar;

  for (let index = 0; index < videoElements.length; index++) {
    const video = videoElements[index];
    var containerParentNode = video.parentNode.parentNode.parentNode;

    for (var i = 0; i < containerParentNode.childNodes.length; i++) {
      if (containerParentNode.childNodes[i].className == 'MediaItem__InfoBar') {
        videoInfoBar = containerParentNode.childNodes[i];
      }
    }

    if (videoInfoBar) {
      video.addEventListener('playing', function () {
        console.log('playing');
        videoInfoBar.style.display = 'none';
      });
      video.addEventListener('pause', function () {
        console.log('paused');
        videoInfoBar.style.display = 'block';
      });
      video.addEventListener('stop', function () {
        console.log('stopped');
        videoInfoBar.style.display = 'block';
      });
    }
  }
}

// Replace the play button with a custom button. Since we can't disable the play button separate from other controls,
// we disable all of them and enable them when clicking the play button.
document
  .querySelectorAll('.MediaItem__Play, .HeaderImage__Play')
  .forEach((element) => {
    // only get visible video, in case one is hidden
    const video = Array.from(element.parentNode.querySelectorAll('video')).find(
      (element) => element.offsetWidth > 0 || element.offsetHeight > 0
    );
    const controls = video.hasAttribute('controls');
    if (controls) {
      video.removeAttribute('controls');
    }

    element.parentNode.addEventListener(
      'click',
      (e) => {
        e.preventDefault();
        video.play();
        if (controls) {
          video.setAttribute('controls', '');
        }
        element.classList.add('d-none');
      },
      { once: true }
    );
  });
